<template>
	<c-dialog ref="dialog" title="分润调拨货款结清核销" mode="slide" width="1000" enable-flex mask-close>
		<template #head>
			<div class="m-detail-tag flex-center-cross">
				<label class="transfer-code">{{detailData.transfer_code || '-'}}</label>
				<c-state tag dict="PROFIT_TRANSFER_STATE" :value="detailData.transfer_state"></c-state>
			</div>
		</template>

		<div class="m-detail-body">
			<c-title>单据信息</c-title>
			<div class="m-head-grid">
				<div class="head-item"><label>对方商户</label><span>{{detailData.merchant_name || '-'}}</span></div>
				<div class="head-item"><label>分润比例</label><span>{{formatRatio(detailData.transfer_ratio)}}</span></div>
				<div class="head-item"><label>供应商</label><span>{{detailData.supplier_name || '-'}}</span></div>
				<div class="head-item"><label>货款结算人</label><span>{{detailData.supplier_contact_realname || '-'}}</span></div>
				<div class="head-item"><label>调拨数量</label><span>{{detailData.total_qty || 0}}</span></div>
				<div class="head-item"><label>接收数量</label><span>{{receiveQty}}</span></div>
			</div>

			<!--货款结算金额（按成本价，转入货款结算人电子账户）+ 转账进度；存在退货时额外展示退款金额-->
			<div class="m-settle-bar">
				<div class="settle-item">
					<label>货款结算金额</label>
					<span class="z-amount">¥{{formatAmount(detailData.settle_amount)}}</span>
					<span :class="goodsTransferClass">{{goodsTransferText}}</span>
				</div>
				<div class="settle-item" v-if="hasRefund">
					<label>退款金额</label>
					<span class="z-refund">¥{{formatAmount(detailData.refund_amount)}}</span>
					<span :class="refundTransferClass">{{refundTransferText}}</span>
				</div>
			</div>

			<c-title>核销备注</c-title>
			<c-input type="textarea" v-model="remark" rows="3" maxlength="500" placeholder="请填写货款结清核销备注（必填）"></c-input>

			<c-title>产品明细</c-title>
			<c-table ref="productTable" :data="productList" border :paging="false">
				<template #empty>
					<c-empty message="暂无产品明细"></c-empty>
				</template>
				<c-table-column label="产品信息" width="300">
					<template #default="{data}">
						<m-product-info :name="data.product_info" :level="data.level_type" :code="showCode(data)" :imei="data.produce_imei"></m-product-info>
					</template>
				</c-table-column>
				<c-table-column label="成本价" width="80">
					<template #default="{data}">{{data.cost_price ? '¥' + data.cost_price : '-'}}</template>
				</c-table-column>
				<c-table-column label="售出价" width="80">
					<template #default="{data}">{{data.sale_price ? '¥' + data.sale_price : '-'}}</template>
				</c-table-column>
				<c-table-column label="分润金额" width="80">
					<template #default="{data}"><span class="z-profit">{{data.profit_amount ? '¥' + data.profit_amount : '-'}}</span></template>
				</c-table-column>
				<c-table-column label="是否接收" width="80">
					<template #default="{data}"><span :class="receiveStateClass(data.receive_state)">{{receiveStateText(data.receive_state)}}</span></template>
				</c-table-column>
				<c-table-column label="销售状态" width="80">
					<template #default="{data}"><c-state dict="PROFIT_SALE_STATE" :value="data.sale_state"></c-state></template>
				</c-table-column>
				<c-table-column label="退货状态" width="80">
					<template #default="{data}">
						<c-state v-if="data.return_state" dict="PROFIT_LINE_RETURN_STATE" :value="data.return_state"></c-state><span v-else>-</span>
					</template>
				</c-table-column>
				<c-table-column label="货款结清" width="80">
					<template #default="{data}"><span :class="checkedClass(data)">{{checkedText(data)}}</span></template>
				</c-table-column>
			</c-table>
		</div>

		<template #button>
			<c-button size="dialog" color="main" @click="confirmCheck">确认核销</c-button>
			<c-button size="dialog" @click="$refs.dialog.close()">取消</c-button>
		</template>
	</c-dialog>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		name: 'profitTransferPaymentCheck',

		computed: {
			...mapState(['saasInfo', 'userInfo']),

			receiveQty() {
				return this.productList.filter(item => item.receive_state == 1).length;
			},

			//是否存在退货（退款金额>0 或存在退货结算记录）
			hasRefund() {
				return Number(this.detailData.refund_amount || 0) > 0
						|| Number(this.detailData.refund_pending_qty || 0) > 0
						|| Number(this.detailData.refund_settled_qty || 0) > 0;
			},

			//货款转账进度：待转账(1,2)==0 且 已转账(3)>0 视为已转账
			goodsTransferText() {
				var pending = Number(this.detailData.goods_pending_qty || 0);
				var settled = Number(this.detailData.goods_settled_qty || 0);
				if (settled == 0 && pending == 0) {
					return '（未转账）';
				}
				if (pending == 0 && settled > 0) {
					return '（已转账）';
				}
				if (settled > 0 && pending > 0) {
					return '（部分转账）';
				}
				return '（未转账）';
			},

			goodsTransferClass() {
				return this.goodsTransferText == '（已转账）' ? 'z-transferred' : 'z-untransferred';
			},

			//退款转账进度
			refundTransferText() {
				var pending = Number(this.detailData.refund_pending_qty || 0);
				var settled = Number(this.detailData.refund_settled_qty || 0);
				if (settled == 0 && pending == 0) {
					return '（未转账）';
				}
				if (pending == 0 && settled > 0) {
					return '（已转账）';
				}
				if (settled > 0 && pending > 0) {
					return '（部分转账）';
				}
				return '（未转账）';
			},

			refundTransferClass() {
				return this.refundTransferText == '（已转账）' ? 'z-transferred' : 'z-untransferred';
			}
		},

		data() {
			return {
				transferId: '',
				detailData: {},
				productList: [],
				remark: ''
			}
		},

		methods: {
			/*********打开弹窗**********/
			open(id) {
				this.transferId = id;
				this.detailData = {};
				this.productList = [];
				this.remark = '';
				this.loadDetail();
				this.$refs.dialog.open();
			},

			/*********加载详情（复用调拨详情接口）**********/
			loadDetail() {
				this.request({
					url: '/profitTransfer/detail',
					data: {id: this.transferId},
					loading: true,
					success: data => {
						this.detailData = data || {};
						this.productList = (data && data.product_list) || [];
					},
					fail: (code, data, msg) => {
						this.$message({message: msg, type: 'error'});
						this.$refs.dialog.close();
						return false;
					}
				});
			},

			/*********金额展示（保留两位）**********/
			formatAmount(val) {
				var num = Number(val || 0);
				return num.toFixed(2);
			},

			/*********分润比例展示**********/
			formatRatio(val) {
				if (val === null || val === undefined || val === '') {
					return '-';
				}
				return Number(val) + '%';
			},

			/*********背贴码展示口径：接收后显示新码**********/
			showCode(data) {
				if (data.receive_state == 1 && data.target_produce_unique_code) {
					return data.target_produce_unique_code;
				}
				return data.produce_unique_code;
			},

			/*********接收状态四态文本**********/
			receiveStateText(state) {
				if (state == 1) {
					return '已接收';
				}
				if (state == 2) {
					return '驳回中';
				}
				if (state == 3) {
					return '已驳回';
				}
				return '待接收';
			},

			/*********接收状态四态颜色**********/
			receiveStateClass(state) {
				if (state == 1) {
					return 'z-received';
				}
				if (state == 2) {
					return 'z-rejecting';
				}
				if (state == 3) {
					return 'z-rejected';
				}
				return 'z-pending';
			},

			/*********是否结清（整单核销口径：仅已接收明细参与货款结清）**********/
			checkedText(data) {
				if (data.receive_state != 1) {
					return '-';
				}
				return this.detailData.payment_check_state == 1 ? '已结清' : '未结清';
			},

			checkedClass(data) {
				if (data.receive_state != 1) {
					return '';
				}
				return this.detailData.payment_check_state == 1 ? 'z-received' : 'z-untransferred';
			},

			/*********确认核销**********/
			confirmCheck() {
				var remark = (this.remark || '').trim();
				if (!remark) {
					this.$message({message: '请填写货款结清核销备注', type: 'warning'});
					return;
				}
				this.$confirm({
					message: '确认对调拨单【' + (this.detailData.transfer_code || '') + '】执行货款结清核销？核销后整单记录为<已结清>，不可撤销！',
					buttonName: '确认核销',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/profitTransfer/payment/check',
							data: {id: this.transferId, remark: remark},
							loading: true,
							success: (res, msg) => {
								this.$message({message: msg || '货款结清核销成功', type: 'success'});
								this.$refs.dialog.close();
								this.$emit('resolve');
							},
							fail: (code, data, msg) => {
								this.$message({message: msg, type: 'error'});
								return false;
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-detail-tag {
		gap: 10px;

		.transfer-code {
			font-size: 13px;
			color: #666;
		}
	}

	.m-detail-body {
		padding: 0 16px;
	}

	.m-head-grid {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 12px;

		.head-item {
			width: 33.33%;
			padding: 6px 0;
			font-size: 13px;

			label {
				color: #999;
				margin-right: 8px;
			}

			span {
				color: #333;
			}
		}
	}

	.m-settle-bar {
		display: flex;
		flex-wrap: wrap;
		gap: 24px;
		padding: 10px 12px;
		margin-bottom: 12px;
		background: #fafafa;
		border-radius: 4px;

		.settle-item {
			display: flex;
			align-items: center;
			font-size: 13px;

			label {
				color: #999;
				margin-right: 8px;
			}

			.z-amount {
				color: #f5222d;
				font-size: 16px;
				font-weight: bold;
				margin-right: 6px;
			}

			.z-refund {
				color: #fa8c16;
				font-size: 16px;
				font-weight: bold;
				margin-right: 6px;
			}
		}
	}

	.z-transferred {
		color: #52c41a;
	}

	.z-untransferred {
		color: #f5222d;
	}

	.z-profit {
		color: #f5222d;
	}

	.z-received {
		color: #52c41a;
	}

	.z-rejecting {
		color: #faad14;
	}

	.z-rejected {
		color: #f5222d;
	}

	.z-pending {
		color: #999;
	}
</style>
